export const EMAIL_TAKEN = '1031';
export const DNI_TAKEN = '1033';
export const NO_PROFESSIONAL_ASSIGNED = '4002';
